function flat(arr) {
    return arr.reduce(function(acc, array) {
        return acc.concat(array);
    }, []);
}

export { flat };
